import React from "react";
import { cn } from "@/lib/utils";

export function PageSection({ title, description, action, children, className }) {
  return (
    <section className={cn("space-y-4", className)}>
      {(title || action) && (
        <div className="flex items-end justify-between gap-4">
          <div>
            {title && (
              <h2 className="font-heading text-xl font-semibold text-gray-900 tracking-tight">
                {title}
              </h2>
            )}
            {description && <p className="text-sm text-gray-500 mt-1">{description}</p>}
          </div>
          {action}
        </div>
      )}
      {children}
    </section>
  );
}

export function Surface({ children, className, padded = true, ...rest }) {
  return (
    <div
      {...rest}
      className={cn(
        "bg-white border border-gray-200 rounded-md overflow-hidden",
        padded && "p-6",
        className
      )}
    >
      {children}
    </div>
  );
}

export function EmptyState({ title, description, action, icon: Icon }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6">
      {Icon && (
        <div className="h-12 w-12 rounded-md bg-gray-100 text-gray-400 flex items-center justify-center mb-4">
          <Icon className="h-6 w-6" strokeWidth={1.5} />
        </div>
      )}
      <p className="font-heading text-base font-semibold text-gray-900">{title}</p>
      {description && <p className="text-sm text-gray-500 mt-1 max-w-sm">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export function FormatINR({ value }) {
  if (value == null) return <span>—</span>;
  return (
    <span className="font-mono tabular-nums">
      ₹{Number(value).toLocaleString("en-IN", { maximumFractionDigits: 0 })}
    </span>
  );
}

export function formatINR(value) {
  if (value == null) return "—";
  return `₹${Number(value).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
}

export function relativeTime(iso) {
  if (!iso) return "Never";
  const date = new Date(iso);
  const diffMs = Date.now() - date.getTime();
  const m = Math.floor(diffMs / 60000);
  if (m < 1) return "Just now";
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  return `${d}d ago`;
}
